<template>
  <BaseAction>
    <div class="d-flex justify-center">
      <SecondaryButton
        @click.native="handleSubmit"
        color="primary"
        :isLoading="isLoading"
      >
        <v-img
          src="@/assets/svg/send_offer_message.svg"
          class="offer-action-icon"
          size="50"
        />
        Submit for Approval
      </SecondaryButton>
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { SUBMIT_DOCUMENT_FOR_APPROVAL } from "@/store/modules/offers/actions";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "SubmitDocumentForApprovalAction",
  components: {
    SecondaryButton,
    BaseAction
  },
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    },
    currentDocumentId() {
      return this.$route.params.documentId;
    }
  },
  methods: {
    ...mapActions({
      submitForApproval: SUBMIT_DOCUMENT_FOR_APPROVAL
    }),
    async handleSubmit() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("file", this.file.data);
      formData.append("status", "pending_approval");

      await this.submitForApproval({
        offerId: this.currentOfferId,
        documentId: this.currentDocumentId,
        data: formData
      });
      this.isLoading = false;
    }
  }
};
</script>
<style lang="scss"></style>
